import i18n from "@/i18n";
import { ForecastModalVue } from "./ForecastModalVue";

/**
 *  Класс для компоненты графика кредита.
 */
export class ScheduleModalVue extends ForecastModalVue {

  /** Открытие файла */
  async openFile() {
    this.fileLoading = true;
    const fileUrl: string = await this.contractService.getFile(
      this.contract.Data.Id,
      "CreditStatementToPdf"
    );
    if (fileUrl.length > 0) {
      window.open(fileUrl, "_blank");
    } else {
      this.alertService.error(
        i18n.t("main.operations.errors.loadStatementError").toString()
      );
    }
    this.fileLoading = false;
  }

  /**
 * Заголовки таблицы
 * @returns {Array<string>} - массив заголовков
 */
  get tableHeaders(): Array<string> {
    return [
      i18n.t("main.contracts.scheduleTable.scheduleTableDate").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTablePercSum").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTableMainSum").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTablePenaltySum").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTableTotalSum").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTableMainRest").toString(),
      i18n.t("main.contracts.scheduleTable.scheduleTableState").toString()
    ];
  }

  /**
 * Ключи таблицы
 * @returns {Array<any>} - массив ключей
 */
  get tableKeys(): Array<any> {
    return [
      "Date",
      "PercSum",
      "MainSum",
      "PenaltySum",
      "TotalSum",
      "MainRest",
      "stateText"
    ];
  }
}
